// extracted by mini-css-extract-plugin
export default {"header":"index_header_zdmEj clearfix","logo":"index_logo_R92WG"};